import React from "react";
import PropTypes from "prop-types";

const iconClasses = {
  'fail': ' color-error',
  'warning': ' color-warning',
  'in_progress': ' color-warning',
  'success': ' color-success'
};
const iconContents = {
  'fail': 'error',
  'warning': 'warning',
  'in_progress': 'watch_later',
  'success': 'check_circle'
};

export default function StatusIcon({ status }) {
  const iconClass = iconClasses[status] || "";
  const iconContent = iconContents[status] || "_";

  return (
    <span className="notification-item__status">
      <i className={`material-icons ${iconClass}`} data-attribute="status-icon">{iconContent}</i>
    </span>
  );
}

StatusIcon.propTypes = {
  status: PropTypes.string.isRequired
};
